import * as React from 'react';
import { FeatureFlagsContext } from './feature-flags-context.deprecated';
/**
 * @deprecated Use useFeatureFlag instead
 */
export function withFeatureFlags<Props>(Component: React.FC<Props>) {
  function ComponentWithFeatureFlags(props: Props) {
    return (
      <FeatureFlagsContext.Consumer>
        {contexts => <Component {...props} {...contexts} />}
      </FeatureFlagsContext.Consumer>
    );
  }

  const componentName = Component.displayName || Component.name || 'Component';
  ComponentWithFeatureFlags.displayName = `withFeatureFlags(${componentName})`;

  return ComponentWithFeatureFlags;
}

export default withFeatureFlags;
